import React from "react"
import styled from "styled-components"

const ButtonStyled = styled.button`
  background: ${({ secondary }) => (secondary ? "none" : "white")};
  padding: 0.5rem 2rem;
  border-radius: 25px;
  border: ${({ secondary }) => (secondary ? "2px solid white" : "none")};
  color: ${({ secondary }) => (secondary ? "white" : "black")};
  :hover {
    background: ${({ secondary }) =>
      secondary ? "rgba(255,255,255,0.2)" : "rgba(255, 255, 255, 0.9)"};
  }
`

const Button = ({ children, isSecondary }) => (
  <ButtonStyled secondary={isSecondary}>{children}</ButtonStyled>
)

export default Button
